import { chakra } from '@chakra-ui/react';

// Fixed brand-identity motif colors — documented exception to no-hardcoded-hex rule.
// X is always orange, O is always teal; never recolored by state.
const MOTIF_X_COLOR = '#F5A623';
const MOTIF_O_COLOR = '#4EC8C8';
const MOTIF_WATERMARK = 'rgba(14,17,22,.05)';

const ChakraSvg = chakra('svg');

interface MotifProps {
  size?: number;
  variant?: 'color' | 'watermark';
}

export default function Motif({ size = 48, variant = 'color' }: MotifProps) {
  const xColor = variant === 'watermark' ? MOTIF_WATERMARK : MOTIF_X_COLOR;
  const oColor = variant === 'watermark' ? MOTIF_WATERMARK : MOTIF_O_COLOR;

  // The SVG has a 200×124 viewBox (from the design-system prototype).
  // Height is proportional: size × (124/200).
  const height = size * (124 / 200);

  return (
    <ChakraSvg
      width={size}
      height={height}
      viewBox="0 0 200 124"
      fill="none"
      aria-hidden="true"
      role="presentation"
    >
      {/* X: two crossed strokes, 10px, rounded caps & joins (DS large-mark spec for 200×124 viewBox) */}
      <g stroke={xColor} strokeWidth={10} strokeLinecap="round" strokeLinejoin="round">
        <line x1="20" y1="24" x2="84" y2="100" />
        <line x1="84" y1="24" x2="20" y2="100" />
      </g>
      {/* O: ring circle, 10px stroke */}
      <circle cx="142" cy="62" r="42" stroke={oColor} strokeWidth={10} fill="none" />
    </ChakraSvg>
  );
}
